/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateBeamShapingGroupDto } from './CreateBeamShapingGroupDto';
import {
    CreateBeamShapingGroupDtoFromJSON,
    CreateBeamShapingGroupDtoFromJSONTyped,
    CreateBeamShapingGroupDtoToJSON,
} from './CreateBeamShapingGroupDto';

/**
 * 
 * @export
 * @interface CreateBeamShapingContainerDto
 */
export interface CreateBeamShapingContainerDto {
    /**
     * 
     * @type {Array<CreateBeamShapingGroupDto>}
     * @memberof CreateBeamShapingContainerDto
     */
    selectedBeamShapings: Array<CreateBeamShapingGroupDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBeamShapingContainerDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBeamShapingContainerDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingContainerDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingContainerDto
     */
    $type?: CreateBeamShapingContainerDtoTypeEnum;
}


/**
 * @export
 */
export const CreateBeamShapingContainerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingContainerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingContainerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateBeamShapingContainerDtoTypeEnum = typeof CreateBeamShapingContainerDtoTypeEnum[keyof typeof CreateBeamShapingContainerDtoTypeEnum];



/**
 * Check if a given object implements the CreateBeamShapingContainerDto interface.
 */
export function instanceOfCreateBeamShapingContainerDto(value?: unknown): value is CreateBeamShapingContainerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateBeamShapingContainerDtoTypeEnum)[0];
}

export function CreateBeamShapingContainerDtoFromJSON(json: any): CreateBeamShapingContainerDto {
    return CreateBeamShapingContainerDtoFromJSONTyped(json, false);
}

export function CreateBeamShapingContainerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamShapingContainerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'selectedBeamShapings': ((json['selectedBeamShapings'] as Array<any>).map(CreateBeamShapingGroupDtoFromJSON)),
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'name': json['name'] == null ? undefined : json['name'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateBeamShapingContainerDtoToJSON(value?: CreateBeamShapingContainerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'selectedBeamShapings': ((value['selectedBeamShapings'] as Array<any>).map(CreateBeamShapingGroupDtoToJSON)),
        'isRequired': value['isRequired'],
        'isEnabled': value['isEnabled'],
        'name': value['name'],
        '$type': value['$type'],
    });
}

